import React, { useEffect, useState } from "react";
import PageLayout from "./PageLayout";
import { useLocation, useNavigate } from "react-router";
import NotMatch from "./NotMatch";
import { Loading } from "../Components/Loading";
import MainSlider from "../Components/Home/MainSlider";
import CenterSection from "../Components/Home/CenterSection";
import CenterItems from "../Components/Home/CenterItems";
import CenterItemsImage from "../Components/Home/CenterItemsImage";
import CenterImage from "../Components/Home/CenterImage";
import IntroFirst from "../Components/Home/IntroFirst";
import ReadMore from "../Components/Home/ReadMore";
import CenterItemsImage2 from "../Components/Home/CenterItemsImage2";
import BoxHeadlineDetail from "../Components/Home/BoxHeadlineDetail";
import BoxHeadlineDetail2 from "../Components/Home/BoxHeadlineDetail2";
import IntroPage from "../Components/Home/IntroPage";
import TextPage from "../Components/Home/TextPage";
import BoxHeadlineDetail3 from "../Components/Home/BoxHeadlineDetail3";
import MagsCorrusel from "../Components/Home/MagsCorrusel";
import ParagraphBox from "../Components/Home/ParagraphBox";
import BoxHeadlineDetail4 from "../Components/Home/BoxHeadlineDetail4";
import ResumeBox from "../Components/Home/ResumeBox";
import CompanyAndJobs from "../Components/Home/CompanyAndJobs";
import Threeparthome from "../Components/Home/Threeparthome";
import IntroSec from "../Components/Home/IntroSec";
import ParagraphBox2 from "../Components/Home/ParagraphBox2";
import LotusPage from "../Components/Lotus/LotusPage";
import BlogPage from "../Components/Lotus/Blogs/Blogpage";
import LotusAllBlog from "../Components/Lotus/LotusAllBlog";
import Twoparthome from "../Components/Home/Twoparthome";
import Twoparthome2 from "../Components/Home/Twoparthome2";
import MagsGrid from "../Components/Home/MagsGrid";

export default function Home(props) {
  const BaseData = props.BaseData;
  const location = useLocation();
  const navigate = useNavigate();
  const [path, setPath] = useState({});
  const [loading, setLoading] = useState(false);
  const [language, setLanguage] = useState({});
  const [pageData, setPageData] = useState({
    "title": "",
    "desc": "",
    'pageBuilder': []
  });
  useEffect(() => {
    async function checkLan (path,dict) {
      try {
        // let loc = await fetch('http://ip-api.com/json');
        // let data = JSON.parse(await loc.text());
        let country = "GB";
        let findLan = dict.filter((value) => value.countryName === country);
        if(findLan.length === 0){
          findLan = dict.filter((value) => value.default === true);
        }
        if(findLan.length !== 0){
          let lan = findLan[0];
          let language = ''
          let firstpart = path.split('/');
          if(firstpart.length > 1){
            firstpart = firstpart[1];
            let search = dict.filter((value) => value.filename === firstpart);
            if(search.length !== 0){
              language = search[0].filename;
            }
          }
          if(language === ''){
            navigate(lan.filename + path)
          }
        }
      } catch(e) {
        let findLan = dict.filter((value) => value.default === true);
        if(findLan.length !== 0){
          let lan = findLan[0];
          let language = ''
          let firstpart = path.split('/');
          if(firstpart.length > 1){
            firstpart = firstpart[1];
            let search = dict.filter((value) => value.filename === firstpart);
            if(search.length !== 0){
              language = search[0].filename;
            }
          }
          if(language === ''){
            navigate(lan.filename + path)
          }
        }
      }
    }
    const checkLanguage = (path) => {
      let firstpart = path.split('/');
      if(firstpart.length > 1){
        firstpart = firstpart[1];
        let search = BaseData.dict.filter((value) => value.filename === firstpart);
        if(search.length !== 0){
          return search[0];
        }
      }
      return ''
    }
    if(path !== location.pathname){
      checkLan(location.pathname,BaseData.dict);
      let lan = checkLanguage(location.pathname);
      let pathname = location.pathname
      if(lan !== ''){
        pathname = pathname.split('/');
        pathname.splice(1, 1);
        if(pathname.length === 1){
          pathname = ['', '']
        }
        pathname = pathname.join('/')
      }
      setPath(location.pathname);
      let data = props.PageIndex[pathname];
      if(data){
        let url = data[lan.filename + '_Data'];
        setLanguage(lan)
        if(url === undefined){
          url = data.Data;
        }
        // fetch page data
        async function fetchPageData(Data) {
          setLoading(true);
          let newPage = await fetch(Data);
          if(newPage.status === 200){
            setPageData(JSON.parse(await newPage.text()))
          } else {
            setPageData({
              "title": "404",
              "desc": "nothing found",
              'pageBuilder': [
                {
                  'type': 'nomatch',
                }
              ]
            })
          }
          setLoading(false);
        }
        fetchPageData(url);
      } else {
        setPageData({
          'pageBuilder': [
            {
              'type': 'nomatch',
            }
          ]
        })
      }
    }
  }, [location, pageData, path, props.PageIndex, BaseData, navigate])
  const pageBuilder = () => {
    let values = [];
    pageData.pageBuilder.forEach((value, index) => {
      switch(value.type){
        case 'nomatch': 
          values.push(<NotMatch key={index}/>);
          break;
        case 'slides':
          values.push(<MainSlider {...props} data={value} key={index}/>);
          break;
        case 'center-title-text':
          values.push(<CenterSection {...props} data={value} key={index}/>);
          break;
        case 'center-item-text':
          values.push(<CenterItems {...props} data={value} key={index}/>);
          break;
        case 'center-item-image':
          values.push(<CenterItemsImage {...props} data={value} key={index}/>);
          break;
        case 'center-image':
          values.push(<CenterImage {...props} data={value} key={index}/>);
          break;
        case 'intro-1':
          values.push(<IntroFirst {...props} data={value} key={index}/>);
          break;
        case 'padding-nav':
          values.push(<div className="navpad"></div>)
          break;
        case 'read-more':
          values.push(<ReadMore {...props} data={value} key={index}/>)
          break;
        case 'image-item-link': 
          values.push(<CenterItemsImage2 {...props} data={value} key={index} language={language}/>);
          break;
        case 'box-headline-detail':
          values.push(<BoxHeadlineDetail {...props} data={value} key={index} language={language}/>);
          break;
        case 'box-headline-detail-2':
          values.push(<BoxHeadlineDetail2 {...props} data={value} key={index} language={language}/>);
          break;
        case 'box-headline-detail-3':
          values.push(<BoxHeadlineDetail3 {...props} data={value} key={index} language={language}/>);
          break;
        case 'box-headline-detail-4':
          values.push(<BoxHeadlineDetail4 {...props} data={value} key={index} language={language}/>);
          break;
        case 'intro-page':
          values.push(<IntroPage {...props} data={value} key={index}/>);
          break;
        case 'paragraph-box':
          values.push(<ParagraphBox {...props} data={value} key={index}/>);
          break;
        case 'text-page':
          values.push(<TextPage {...props} data={value} key={index}/>);
          break;
        case 'send-resume':
          values.push(<ResumeBox {...props} data={value} key={index}/>);
          break;
        case 'company-jobs':
          values.push(<CompanyAndJobs {...props} data={value} key={index}/>);
          break;
        case 'mags-corrusel':
          values.push(<MagsCorrusel {...props} data={value} key={index} language={language}/>);
          break;
        case 'mags-grid':
          values.push(<MagsGrid {...props} data={value} key={index} language={language}/>);
          break;
        case 'three-part-home':
          values.push(<Threeparthome {...props} data={value} key={index}/>);
          break;
        case 'two-part-home':
          values.push(<Twoparthome {...props} data={value} key={index}/>);
          break;
        case 'two-part-home-2':
          values.push(<Twoparthome2 {...props} data={value} key={index} language={language}/>);
          break;
        case 'intro-2':
          values.push(<IntroSec {...props} data={value} key={index}/>);
          break;
        case 'paragraph-box-2':
          values.push(<ParagraphBox2 {...props} data={value} key={index} language={language}/>);
          break;
        case 'lotus':
          values.push(<LotusPage {...props} data={value} key={index} language={language}/>);
          break;
        case 'lotus-all-blog':
          values.push(<LotusAllBlog {...props} data={value} key={index} language={language}/>);
          break;
        case 'lotus-blog':
          values.push(<BlogPage {...props} data={value} key={index} location={location}/>);
          break;
        default: 
          break;
      }
    });
    if(values.length && !loading){
      return values
    } else {
      return (
        <div style={{marginTop: "120px"}}>
          <Loading/>
        </div>
      )
    }
  }

  return (
    <PageLayout {...props} language={language} dict={BaseData.dict} mainLogo={BaseData.mainLogo} texts={BaseData.texts} nav={BaseData.nav} footer={BaseData.footer} ctaNav={BaseData['call-to-action-nav']}>
      {pageBuilder()}
    </PageLayout>
  );
}